import React, { Component } from 'react'
// import UserProfile from '../components/Profile/Profile'
import { Query } from "react-apollo"
import { Proposes3 } from "../../../queries/propose"
import * as dayjs from 'dayjs'
import './dashboard.scss'

import ActivityCard from "../../../components/activityCard/activityCard"
import ErrorBoundary from '../../../components/errorBoundary/errorBoundary'
import Calendar from "../../../components/calendar/calendar";

export default class Dashboard extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }

        this.player = {}
    }

    render() {
        const cache = JSON.parse(sessionStorage.getItem('OITO'));

        if (cache) {
            this.player = cache.user
        } else {
            window.location.href = '/login'
        }

        return (
            <div className='dashboard col-xs-12' style={{ maxWidth: "980px"}}>
                <div className="row center-xs">
                    <div className={'col-xs-12 col-md-8 last-xs first-md'}>
                        <div>
                            <h1>Últimas Atividades</h1>
                        </div>
                        <div className="row center-xs">
                            <Query query={Proposes3} variables={{ id: this.player.id }}>
                                {res => {
                                    var proposes = []
                                    if (res.data && res.data.user && res.data.user.length > 0) {
                                        if (res.data.user.proposes && res.data.user.proposesFrom) {
                                            proposes = res.data.user.proposes.concat(res.data.user.proposesFrom)
                                        } else if (res.datares.data.user.proposes) {
                                            proposes = res.data.user.proposes
                                        } else if (res.data.user.proposesFrom) {
                                            proposes = res.data.user.proposesFrom
                                        } else {
                                            proposes = []
                                        }

                                        // const propsort = proposes.sort(proposes.date).reverse().splice(0, 3)
                                        const propsort = proposes.sort(function (a, b) {
                                            return new Date(b.date) - new Date(a.date)
                                        })
                                        // const lastest = propsort.splice(0, 3)
                                        // console.log(propsort);
                                        return propsort.length ? propsort.map((prop, i) => {
                                            return <ErrorBoundary key={i} ><ActivityCard link={prop.id} catg={prop.anuncio ? prop.anuncio.skill.name : prop.skill} date={dayjs(prop.dateInitF ? prop.dateInitF : prop.dateInit).format("DD/MM/YYYY")} status={prop.status} /></ErrorBoundary>
                                        }) : <p>Você não tem nenhuma solicitação no momento</p>
                                    } else {
                                        return null
                                    }
                                }}
                            </Query>
                        </div>
                    </div>
                    <div className={'calendarContainer col-xs-12 col-md-4 first-xs last-md'}>
                        <div>
                            <h1>Calendário</h1>
                        </div>
                        <ErrorBoundary><Calendar /></ErrorBoundary>
                    </div>
                </div>

            </div>
        )
    }
}
